import { FunctionComponent, ReactNode } from 'react'
import classnames from 'classnames'

/**
 * Standard content wrapper for logged-in pages.
 * `fill` makes the page fit the viewport so a list scrolls inside its
 * table (sticky header) instead of scrolling the whole page. With
 * `fill="desktop"` it only does so on desktop; on phones and tablets the page
 * scrolls normally (use it when the content above the table is tall).
 */
const Page: FunctionComponent<{
  children: ReactNode
  className?: string
  fill?: boolean | 'desktop'
}> = ({ children, className, fill }) => (
  <div
    className={classnames(
      'app-width app-page',
      fill === true && 'app-page-fill',
      fill === 'desktop' && 'app-page-fill-desktop',
      className
    )}
  >
    {children}
  </div>
)

export default Page
